import { Market, RangeFilter, SizeClass, SizeClassification } from "./_types";


export const LIB_CLASSIFICATIONS_FRUT_HARVEST: SizeClassification[] = [

    {
        id: "eu_nectarine_weight",
        cropId: "nectarine",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_eu",
        label: "Nectarine Weight Classification (EU)",
        market: Market.EU,
        sizing:[
            {
                cartonQty: 22,
                size: SizeClass.AAAA,
                upperBound: {
                    value: 277,
                    operator: RangeFilter.GTE,
                }
            },
            {
                cartonQty: 24,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 250,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 277,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 26,
                size: SizeClass.AA,
                lowerBound: {
                    value: 227,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 250,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 28,
                size: SizeClass.AA,
                lowerBound: {
                    value: 207,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 227,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 32,
                size: SizeClass.A,
                lowerBound: {
                    value: 181,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 207,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 36,
                size: SizeClass.A,
                lowerBound: {
                    value: 158,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 181,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 40,
                size: SizeClass.B,
                lowerBound: {
                    value: 143,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 158,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 44,
                size: SizeClass.B,
                lowerBound: {
                    value: 127,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 143,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 48,
                size: SizeClass.C,
                lowerBound: {
                    value: 117,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 127,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 52,
                size: SizeClass.C,
                lowerBound: {
                    value: 108,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 117,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 60,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 92,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 108,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 66,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 92,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "us_nectarine_weight",
        cropId: "nectarine",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_us",
        label: "Nectarine Weight Classification (US)",
        market: Market.US,
        sizing:[
            {
                cartonQty: 30,
                size: SizeClass.AAAA,
                upperBound: {
                    value: 277,
                    operator: RangeFilter.GTE,
                }
            },
            {
                cartonQty: 32,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 256,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 277,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 36,
                size: SizeClass.AA,
                lowerBound: {
                    value: 228,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 256,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 40,
                size: SizeClass.AA,
                lowerBound: {
                    value: 203,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 228,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 44,
                size: SizeClass.A,
                lowerBound: {
                    value: 184,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 203,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 48,
                size: SizeClass.A,
                lowerBound: {
                    value: 167,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 184,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 52,
                size: SizeClass.B,
                lowerBound: {
                    value: 152,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 167,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 56,
                size: SizeClass.B,
                lowerBound: {
                    value: 141,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 152,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 60,
                size: SizeClass.B,
                lowerBound: {
                    value: 130,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 141,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 66,
                size: SizeClass.C,
                lowerBound: {
                    value: 118,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 130,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 72,
                size: SizeClass.C,
                lowerBound: {
                    value: 106,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 118,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 78,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 96,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 106,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 84,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 96,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "eu_peach_weight",
        cropId: "peach",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_eu",
        label: "Peach Weight Classification (EU)",
        market: Market.EU,
        sizing:[
            {
                cartonQty: 22,
                size: SizeClass.AAAA,
                upperBound: {
                    value: 277,
                    operator: RangeFilter.GTE,
                }
            },
            {
                cartonQty: 24,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 250,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 277,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 26,
                size: SizeClass.AA,
                lowerBound: {
                    value: 227,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 250,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 28,
                size: SizeClass.AA,
                lowerBound: {
                    value: 207,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 227,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 32,
                size: SizeClass.A,
                lowerBound: {
                    value: 181,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 207,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 36,
                size: SizeClass.A,
                lowerBound: {
                    value: 158,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 181,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 40,
                size: SizeClass.B,
                lowerBound: {
                    value: 143,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 158,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 44,
                size: SizeClass.B,
                lowerBound: {
                    value: 127,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 143,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 48,
                size: SizeClass.C,
                lowerBound: {
                    value: 117,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 127,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 52,
                size: SizeClass.C,
                lowerBound: {
                    value: 108,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 117,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 60,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 92,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 108,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 66,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 92,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "us_peach_weight",
        cropId: "peach",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_us",
        label: "Peach Weight Classification (US)",
        market: Market.US,
        sizing:[
            {
                cartonQty: 30,
                size: SizeClass.AAAA,
                upperBound: {
                    value: 277,
                    operator: RangeFilter.GTE,
                }
            },
            {
                cartonQty: 32,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 256,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 277,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 36,
                size: SizeClass.AA,
                lowerBound: {
                    value: 228,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 256,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 40,
                size: SizeClass.AA,
                lowerBound: {
                    value: 203,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 228,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 44,
                size: SizeClass.A,
                lowerBound: {
                    value: 184,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 203,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 48,
                size: SizeClass.A,
                lowerBound: {
                    value: 167,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 184,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 52,
                size: SizeClass.B,
                lowerBound: {
                    value: 152,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 167,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 56,
                size: SizeClass.B,
                lowerBound: {
                    value: 141,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 152,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 60,
                size: SizeClass.B,
                lowerBound: {
                    value: 130,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 141,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 66,
                size: SizeClass.C,
                lowerBound: {
                    value: 118,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 130,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 72,
                size: SizeClass.C,
                lowerBound: {
                    value: 106,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 118,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 78,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 96,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 106,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 84,
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 89,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "eu_plumb_weight",
        cropId: "plum",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_eu",
        label: "Plumb Weight Classification (EU)",
        market: Market.EU,
        sizing:[
            {
                cartonQty: 24,
                size: SizeClass.AAAA,
                upperBound: {
                    value: 225,
                    operator: RangeFilter.GTE,
                }
            },
            {
                cartonQty: 26,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 204,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 225,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 28,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 182,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 204,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 30,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 170,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 182,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 32,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 159,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 170,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 36,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 142,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 159,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 40,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 128,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 142,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 44,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 116,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 128,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 48,
                size: SizeClass.AA,
                lowerBound: {
                    value: 104,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 116,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 54,
                size: SizeClass.AA,
                lowerBound: {
                    value: 93,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 104,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 60,
                size: SizeClass.A,
                lowerBound: {
                    value: 83,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 93,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 66,
                size: SizeClass.A,
                lowerBound: {
                    value: 76,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 83,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 72,
                size: SizeClass.B,
                lowerBound: {
                    value: 69,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 76,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 78,
                size: SizeClass.B,
                lowerBound: {
                    value: 64,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 69,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 84,
                size: SizeClass.C,
                lowerBound: {
                    value: 57,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 64,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 92,
                size: SizeClass.C,
                lowerBound: {
                    value: 52,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 57,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 52,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "us_plumb_weight",
        cropId: "plum",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_us",
        label: "Plumb Weight Classification (US)",
        market: Market.US,
        sizing:[
            {
                cartonQty: 32,
                size: SizeClass.AAAA,
                upperBound: {
                    value: 228,
                    operator: RangeFilter.GTE,
                }
            },
            {
                cartonQty: 36,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 200,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 228,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 40,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 180,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 200,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 44,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 161,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 180,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 48,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 148,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 161,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 52,
                size: SizeClass.AAAA,
                lowerBound: {
                    value: 135,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 148,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 56,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 123,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 135,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 60,
                size: SizeClass.AAA,
                lowerBound: {
                    value: 115,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 123,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 66,
                size: SizeClass.AA,
                lowerBound: {
                    value: 103,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 115,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 72,
                size: SizeClass.AA,
                lowerBound: {
                    value: 94,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 103,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 78,
                size: SizeClass.A,
                lowerBound: {
                    value: 85,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 94,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 84,
                size: SizeClass.A,
                lowerBound: {
                    value: 79,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 85,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 88,
                size: SizeClass.B,
                lowerBound: {
                    value: 75,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 79,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 98,
                size: SizeClass.B,
                lowerBound: {
                    value: 66,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 75,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 108,
                size: SizeClass.C,
                lowerBound: {
                    value: 60,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 66,
                    operator: RangeFilter.LT,
                },
            },
            {
                cartonQty: 120,
                size: SizeClass.C,
                lowerBound: {
                    value: 54,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 60,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 54,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "sa_kiwi_weight",
        cropId: "kiwi",
        measureId: "frut_weight",
        calculationId: "frut_weight_classification_sa",
        label: "Kiwi Weight Classification (RSA)",
        market: Market.RSA,
        sizing:[
            {
                size: SizeClass.AAAA,
                upperBound: {
                    value: 144,
                    operator: RangeFilter.GTE,
                }
            },
            {
                size: SizeClass.AAA,
                lowerBound: {
                    value: 112,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 144,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.AA,
                lowerBound: {
                    value: 85,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 112,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.A,
                lowerBound: {
                    value: 70,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 85,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.B,
                lowerBound: {
                    value: 60,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 70,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.C,
                lowerBound: {
                    value: 20,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 60,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.DEFAULT,
                lowerBound: {
                    value: 20,
                    operator: RangeFilter.LT,
                },
            },
        ]
    },
    {
        id: "asia_cherry_diameter",
        cropId: "cherry",
        measureId: "frut_diameter",
        calculationId: "frut_diameter_classification_asia",
        label: "Cherry Diameter Classification (Asia)",
        market: Market.Asia,
        sizing:[
            {
                size: SizeClass.J4,
                upperBound: {
                    value: 32,
                    operator: RangeFilter.GTE,
                }
            },
            {
                size: SizeClass.J3,
                lowerBound: {
                    value: 30,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 32,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.J2,
                lowerBound: {
                    value: 28,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 30,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.J,
                lowerBound: {
                    value: 26,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 28,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.XL,
                lowerBound: {
                    value: 24,
                    operator: RangeFilter.GTE,
                },
                upperBound: {
                    value: 26,
                    operator: RangeFilter.LT,
                },
            },
            {
                size: SizeClass.L,
                lowerBound: {
                    value: 24,
                    operator: RangeFilter.LT,
                },
            },
        ]
    }
];